import { graphql } from 'gatsby';
import { motion } from 'framer-motion';
import { Hero } from '../components/hero';
import { Container } from '../components/container';
import { Columns, Column } from '../components/columns';
import { AnimatedText } from '../components/animated-text';
import { Vine } from '../components/vine';
import { Story } from '../components/story';
import { useVisibleDelay } from '../hooks/use-delay';

const introVariants = {
  hidden: { opacity: 0, transform: 'translateY(20px)' },
  visible: { opacity: 1, transform: 'translateY(0px)' },
};

export default function Home({ data }) {
  const stories = data?.stories?.nodes.map((file) => file.childMarkdownRemark);
  const [ref, animateIntroSection] = useVisibleDelay();

  return (
    <>
      {/* hero + intro */}
      <Hero isFull />
      <Container className="py3">
        <Columns>
          <Column className="one-third-ish">
            <h2 ref={ref} className="undervine">
              <span>
                <AnimatedText isVisible={animateIntroSection}>
                  Seeds are small but packed with potential.
                </AnimatedText>
                {animateIntroSection && <Vine />}
              </span>
            </h2>
          </Column>
          <Column className="two-thirds-ish">
            <motion.div
              variants={introVariants}
              animate={animateIntroSection ? 'visible' : 'hidden'}
              transition={{
                type: 'tween',
                duration: 0.5,
                delay: 0.4,
              }}
            >
              <p>
                Given the right resources, something prosperous and beautiful
                can grow.
              </p>
              <p>
                Here in northeastern Minnesota, good people and ideas can
                flourish, too, with the help of timely funding, technical
                assistance, and engaged community members.
              </p>
              <p>
                The Northland Foundation, alongside many incredible partners, worked extra hard this past year to cultivate opportunities and nurture growth. This report gives a look at what our region accomplished, together.
              </p>
            </motion.div>
          </Column>
        </Columns>
      </Container>

      {/* stories */}
      <Container className="py0">
        {stories?.map((post, i) => {
          return (
            <Story
              key={post.id}
              post={post}
              className={i % 2 === 1 ? 'has-right-image' : ''}
              lastChild={i === stories.length - 1}
            />
          );
        })}
      </Container>
    </>
  );
}

export const pageQuery = graphql`
  query {
    stories: allFile(
      filter: { sourceInstanceName: { eq: "stories" }, extension: { eq: "md" } }
      sort: { fields: childrenMarkdownRemark___frontmatter___order, order: ASC }
    ) {
      nodes {
        childMarkdownRemark {
          id
          excerpt(pruneLength: 240)
          fields {
            slug
          }
          frontmatter {
            order
            project
            title
            excerpt
            image {
              id
              childImageSharp {
                gatsbyImageData(
                  width: 500
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
            optionalImage {
              id
              childImageSharp {
                gatsbyImageData(
                  width: 500
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
      }
    }
  }
`;
